import { render, staticRenderFns } from "./ServiceDomainServerInfo.vue?vue&type=template&id=f2cfb4e8&"
import script from "./ServiceDomainServerInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceDomainServerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2cfb4e8')) {
      api.createRecord('f2cfb4e8', component.options)
    } else {
      api.reload('f2cfb4e8', component.options)
    }
    module.hot.accept("./ServiceDomainServerInfo.vue?vue&type=template&id=f2cfb4e8&", function () {
      api.rerender('f2cfb4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServiceDomainServerInfo.vue"
export default component.exports